//const reactElement = document.getElementById('swup');

function checkForReactClass() {
  const targetElement = document.querySelector('.page-gift-card');
  if (targetElement) {
	location.reload();
  }
}
document.addEventListener('swup:contentReplaced', checkForReactClass);

function applyFilters(e) {
	e.preventDefault();

	var sizesContainer = document.querySelector('[data-type="sizes"]');
	var activeItems = sizesContainer.querySelectorAll('.js-filter-item.active');
	var sizesValues = Array.from(activeItems).map(function (item) {
	  return item.getAttribute('data-value');
	});

	var collectionCards = document.querySelectorAll('.js-collection-card');
	collectionCards.forEach(function (card) {
	  var outstockAttribute = card.getAttribute('data-outstock');
	  outstockAttribute = outstockAttribute ? outstockAttribute : '';

	  var outstockSizes = outstockAttribute.split(',');

	  var isHidden = sizesValues.some(function (size) {
		return outstockSizes.includes(size);
	  });

	  setTimeout(function () {
		if (isHidden) {
		  card.classList.add('isHidden');
		  card.setAttribute("filter", "true");
		} else {
		  card.classList.remove('isHidden');
		  card.setAttribute("filter", "false");
		}
	  }, 500);
	});
  }

  // Step 1: Attach an event listener to the "apply filters" button
  function attachFilterEventListener() {
	var applyFiltersButton = document.querySelector('.js-apply-filter');
	if (applyFiltersButton) {
	  applyFiltersButton.addEventListener('click', applyFilters);
	}
  }

  // Attach the event listener when the page initially loads
  attachFilterEventListener();

  // If you are using Swup for page transitions, you may need to reattach the listener
  document.addEventListener('swup:contentReplaced', function () {
	// Detach the previous event listener
	var applyFiltersButton = document.querySelector('.js-apply-filter');
	if (applyFiltersButton) {
	  applyFiltersButton.removeEventListener('click', applyFilters);
	}

	// Attach the event listener to the new content
	attachFilterEventListener();
  });